import { Hero } from "../components/Hero";
import { AboutVisionSection } from "./AboutVisionPage";
import { ContactSection } from "./ContactPage";
import { ProgramsSection } from "./ProgramsPage";

export function HomePage({ uni, heroImageSrc, logoSrc }) {
  return (
    <main id="main" className="flex-1">
      <Hero uni={uni} heroImageSrc={heroImageSrc} />
      <div className="mx-auto max-w-6xl space-y-12 px-4 py-8 sm:space-y-14 sm:px-6 sm:py-10">
        <AboutVisionSection uni={uni} />
        <ProgramsSection uni={uni} logoSrc={logoSrc} />
        <ContactSection uni={uni} />
      </div>
    </main>
  );
}
